import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon from MUI

import { panApi } from "../../app/slices/panSlice";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import Swal from "sweetalert2";
import Filter from "../../components/Filter";
import { useFormik } from "formik";
import axiosInstanceMainUrl from "../../utils/axiosInstanceMainUrl";
import Loader from "../digitalGold/Loader";
import useFilterHandler from "../../components/filterhandler";
import axiosInstance from "../../utils/axiosInstance";

export default function Pan() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(panApi());
  // }, [dispatch]);

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    name: "",
    panNo: "",
    customerRefNo: "",
  });

  const url = `/api/admin/pan/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);

  useEffect(() => {
    // setUsersList(sliceResponse);
    // useFilterHandler(url, filterData,setFilterData)
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    //  else {
    //   // toast.success(message);
    // }
  }, [toastTrigger]);

  const roleResponse = useSelector((state) => state.login.login.role);

  const sliceResponse = useSelector((state) => state.pan.pan.data);
  const stateLoading = useSelector((state) => state.pan.loading);
  const columnHelper = createMRTColumnHelper();
  const columns = [
    // Identifying Information
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("nameAsPerPan", {
      header: "Name As Per PAN",
      size: 200,
      Cell: (cell) => cell.row.original?.nameAsPerPan,
    }),

    // Personal Details
    columnHelper.accessor("Name", {
      header: "Name",
      size: 200,
      Cell: (cell) => cell.row.original?.Name,
    }),

    columnHelper.accessor("NameOnTheCard", {
      header: "Name on the Card",
      size: 200,
      Cell: (cell) => cell.row.original?.NameOnTheCard,
    }),
    columnHelper.accessor("PanNumber", {
      header: "PAN Number",
      size: 150,
      Cell: (cell) => cell.row.original?.PanNumber,
    }),
    columnHelper.accessor("dob", {
      header: "Date of Birth",
      size: 150,
      Cell: (cell) => cell.row.original?.dob,
    }),
    columnHelper.accessor("email", {
      header: "Email",
      size: 250,
      Cell: (cell) => cell.row.original?.email,
    }),

    // Status
    columnHelper.accessor("STATUS", {
      header: "Status",
      size: 150,
      Cell: (cell) => cell.row.original?.STATUS,
    }),
    // columnHelper.accessor("StatusDescription", {
    //   header: "Status Description",
    //   size: 250,
    //   Cell: (cell) => cell.row.original?.StatusDescription ?? "N/A",
    // }),
    // columnHelper.accessor("PanHolderStatusType", {
    //   header: "PAN Holder Status Type",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.PanHolderStatusType ?? "N/A",
    // }),
    // columnHelper.accessor("panHolderStatusType", {
    //   header: "PAN Holder Status Type (Lowercase)",
    //   size: 250,
    //   Cell: (cell) => cell.row.original?.panHolderStatusType ?? "N/A",
    // }),
    // columnHelper.accessor("LastUpdate", {
    //   header: "Last Update",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.LastUpdate ?? "N/A",
    // }),
    // columnHelper.accessor("source_id", {
    //   header: "Source ID",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.source_id ?? "N/A",
    // }),

    // Timestamps
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 150,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 150,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),
  ];

  if (roleResponse?.Pan?.update === 1) {
    columns.push(
      columnHelper.accessor("Actions", {
        header: "Block",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          const rowData = cell.row.original;

          return (
            <Box>
              {roleResponse?.Pan?.update === 1 && (
                <Tooltip title="Ristrict">
                  <IconButton
                    onClick={() => {
                      handleOpen(rowData);
                      // setOpen(true)
                      // handleEdit(rowData, "/role_edit");
                      // setRefresh(!refresh);
                      // setshowUpdateButton(!showUpdateButton);
                    }}
                  >
                    <EditIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      }),
    );
  }

  const [open, setOpen] = useState(false);

  const [selectedRow, setselectedRow] = useState({});
  // console.log("selectedRow: ", selectedRow);
  const [checked, setChecked] = useState({
    aBuy: false,
    aSell: false,
    aJewellery: false,
    mBuy: false,
    mSell: false,
    aRedeem: false,
    mRedeem: false,
  });

  // console.log("checked: ", checked);
  const handleClose = () => {
    setOpen(false);
    setselectedRow({});
    setChecked({
      aBuy: false,
      aSell: false,
      aJewellery: false,
      mBuy: false,
      mSell: false,
      aRedeem: false,
      mRedeem: false,
    });
  };

  const handleOpen = (data) => {
    setselectedRow(data);

    // Pre-fill checkboxes based on row data
    setChecked({
      aBuy: data.aBuy ?? false,
      aSell: data.aSell ?? false,
      aJewellery: data.aJewellery ?? false,
      mBuy: data.mBuy ?? false,
      mSell: data.mSell ?? false,
      aRedeem: data.aRedeem ?? false,
      mRedeem: data.mRedeem ?? false,
    });

    setOpen(true);
  };

  const handleChange = (event) => {
    setChecked({
      ...checked,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...checked,
        pan_number: selectedRow.PanNumber,
      };
      // console.log("Submitting payload: ", payload);

      let url = `/block/pan`;
      // let url = baseUrl + "/block/pan";
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.post(
        url,
        payload,
        //    {
        //   headers,
        // }
      );
      // const response = await axios.post(url, payload, {
      //   headers,
      // });
      // console.log("response: ", response);

      if (response.status === 200) {
        // dispatch(panApi());
        apiCall(false);
        await Swal.fire({
          icon: "success",
          title: response.data.message || "Blocked successfully",
          showConfirmButton: false,
          timer: 1500,
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = "2000";
            }
          },
        });

        handleClose(); // close modal after success
      } else {
        console.log("Something went wrong!:");
      }
    } catch (error) {
      console.error("Error submitting:", error);
      await Swal.fire({
        icon: "error",
        title: "Error while Blocked !",
        text: error?.response?.data?.message || "Something went wrong",
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = "2000";
          }
        },
      });
    }
  };
  ////////////////-------new code----------

  //    const [result, setResults] = useState();

  //  const handleClearFilters = () => {
  //     // Reset filter state
  //     console.log("reset==============")
  //     setFilterData((prev) => {
  //     const cleared = {};
  //     console.log("fffffffffffffffff")
  //     Object.entries(prev).forEach(([key, value]) => {
  //       if (typeof value === "boolean") cleared[key] = false;
  //       else cleared[key] = "";
  //     });

  //     // Onclear()

  //     return cleared;
  //   });
  //     const params = false
  //     apiCall(params)

  //   };

  //   const handleFilterSubmit = async (event) => {
  //     event.preventDefault();
  //    apiCall()
  //   };
  // const [loader, setloader] = useState(true)

  //  const apiCall = async (params = true) => {
  //   try {

  //     let config = {};

  //     if (params) {
  //       config = {
  //         params: {
  //          ...filterData
  //         },
  //       };
  //     }

  //     const response = await axiosInstanceMainUrl.get(
  //       "/api/admin/pan/list",
  //       config
  //     );

  //     const { data, message, error } = response.data;

  //     console.log("API RESPONSE:", response.data);
  //     console.log("DATA:", data);

  //     if (!error) {
  //       setloader(false)
  //       setResults(data);
  //     }
  //   } catch (err) {
  //     console.error("API ERROR:", err);

  //     // optional: show toast / alert
  //     // toast.error(err.response?.data?.message || "Something went wrong");
  //   }
  // };

  return (
    <>
      {/*  */}
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"Pan"}
        setFilterData={setFilterData}
      />
      {loader ? (
        <Loader />
      ) : (
        <CustomTable
          columns={columns}
          data={results}
          loading={loader}
          permissionKey="Pan"
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          {/* Header */}
          {/* <Typography variant="body1" gutterBottom>
            Block User from Refinery Operations by PAN Number
          </Typography> */}
          <Typography variant="body1" gutterBottom align="center">
            Block User from Refinery Operations by PAN Number
          </Typography>

          <Divider sx={{ mb: 2 }} />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography variant="body2" fontWeight={600} color="text.secondary">
              {selectedRow.NameOnTheCard}
            </Typography>
            <Typography variant="body2" fontWeight={600} color="text.secondary">
              {selectedRow.PanNumber}
            </Typography>
          </Box>

          <Divider sx={{ mb: 2 }} />

          {/* Options */}

          <FormGroup>
            <Grid container spacing={1.5}>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.aBuy}
                      onChange={handleChange}
                      name="aBuy"
                      color="secondary"
                    />
                  }
                  label="Augmont Buy"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.aSell}
                      onChange={handleChange}
                      name="aSell"
                      color="secondary"
                    />
                  }
                  label="Augmont Sell"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.aJewellery}
                      onChange={handleChange}
                      name="aJewellery"
                      color="secondary"
                    />
                  }
                  label="Augmont Jewellery"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.mBuy}
                      onChange={handleChange}
                      name="mBuy"
                      color="secondary"
                    />
                  }
                  label="MMTC-PAMP Buy"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.mSell}
                      onChange={handleChange}
                      name="mSell"
                      color="secondary"
                    />
                  }
                  label="MMTC-PAMP Sell"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.aRedeem}
                      onChange={handleChange}
                      name="aRedeem"
                      color="secondary"
                    />
                  }
                  label="Augmont Redeem"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.mRedeem}
                      onChange={handleChange}
                      name="mRedeem"
                      color="secondary"
                    />
                  }
                  label="MMTC-PAMP Redeem"
                />
              </Grid>
            </Grid>
          </FormGroup>

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
            }}
          >
            <Button variant="outlined" color="error" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
